/**
 * Feature names found in the DeviceLicense.featureName GraphQL field. These originate in Revenera,
 * the system that we use for licensing.
 */
export const LICENSE_FEATURE_NAMES = {
	ADPSMChannel: 'ADPSM.Channel',
	ANX4Channel: 'ANX4.Channel',
	Auracast: 'Auracast.Feature'
};
